import { XGridDefaultColumn } from '@AMIEWEB/Common/XGrid/cells/XGridDefaults';
import { GridPreProcessEditCellProps } from '@mui/x-data-grid';
import { xGridNumberSort } from '@AMIEWEB/Common';
import { FurnitureInclude } from './FurnitureInclude';
import { FurnitureUtility } from './UtilityBillable';
import { StandardCost } from './StandardCost';
import { CostToTraveler } from './CostToTraveler';
import { Quantity } from './Quantity';
import { CostToTravelerCell } from './EditFurniture/CostToTravelerEdit';
import { QuantityCell } from './EditFurniture/QuantityEdit';
import { IncludeCell } from './EditFurniture/IncludeEdit';
import { BillableCell } from './EditFurniture/BillableEdit';
import { missingField } from 'app/constants';

export const defaultFurnitureColumn = {
  ...XGridDefaultColumn,
  flex: 0,
};

export const isInvalidFieldBasedOnInclude = (isIncluded, fieldToValidate) => {
  if (isIncluded) {
    return fieldToValidate === '' || fieldToValidate === missingField || fieldToValidate === null;
  }
  return false;
};

export const getFurnitureGridColumns = (t, isExpanded, isModEdit, furnitureEditRequests, classes) => [
  {
    field: 'include',
    headerName: t('placement.placementMods.include'),
    width: 103,
    hide: false,
    editable: isModEdit,

    renderCell: FurnitureInclude,
    renderEditCell: IncludeCell({
      gridIdentifier: 'Furniture',
    }),
  },
  {
    ...defaultFurnitureColumn,
    field: 'description',
    headerName: t('placement.placementMods.description'),
    width: 285,
    hide: false,
  },
  {
    ...defaultFurnitureColumn,
    field: 'standardCost',
    headerName: t('placement.placementMods.standardCost'),
    width: 127,
    align: 'right',
    type: 'number',
    hide: false,
    renderCell: StandardCost,
    sortComparator: xGridNumberSort,
  },
  {
    ...defaultFurnitureColumn,
    headerName: t('placement.placementMods.costToTraveler'),
    field: 'costToTraveler',
    width: 119,
    hide: false,
    align: 'right',
    type: 'number',
    editable: isModEdit,

    renderCell: CostToTraveler,
    renderEditCell: CostToTravelerCell({
      gridIdentifier: 'Furniture',
    }),
    preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      if (isInvalidFieldBasedOnInclude(params?.row?.include, params?.row?.costToTraveler)) {
        return { ...params.props.row, error: true, errorField: 'costToTraveler' };
      } else {
        return { ...params.props, error: false, errorField: null };
      }
    },
    cellClassName: params => {
      if (isInvalidFieldBasedOnInclude(params?.row?.include, params?.row?.costToTraveler)) {
        return classes.isErrorCell;
      } else {
        return null;
      }
    },
    sortComparator: xGridNumberSort,
  },
  {
    ...defaultFurnitureColumn,
    headerName: t('placement.placementMods.quantity'),
    field: 'quantity',
    width: isExpanded ? 860 : 144,
    hide: false,
    editable: isModEdit,

    renderCell: Quantity,
    renderEditCell: QuantityCell,
    preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      if (isInvalidFieldBasedOnInclude(params?.row?.include, params?.row?.quantity)) {
        return { ...params.props.row, error: true, errorField: 'quantity' };
      } else {
        return { ...params.props, error: false, errorField: null };
      }
    },
    cellClassName: params => {
      if (isInvalidFieldBasedOnInclude(params?.row?.include, params?.row?.quantity)) {
        return classes.isErrorCell;
      } else {
        return null;
      }
    },
    sortComparator: xGridNumberSort,
  },
];

export const getUtilityGridColumns = (t, isExpanded, isModEdit, utilityEditRequests, classes) => [
  {
    field: 'include',
    headerName: t('placement.placementMods.include'),
    width: 103,
    hide: false,
    editable: isModEdit,

    renderCell: FurnitureInclude,
    renderEditCell: IncludeCell({
      gridIdentifier: 'Utility',
    }),
  },
  {
    ...defaultFurnitureColumn,
    field: 'description',
    headerName: t('placement.placementMods.description'),
    width: 285,
    hide: false,
  },
  {
    ...defaultFurnitureColumn,
    field: 'standardCost',
    headerName: t('placement.placementMods.standardCost'),
    width: 127,
    align: 'right',
    type: 'number',
    hide: false,
    renderCell: StandardCost,
    sortComparator: xGridNumberSort,
  },
  {
    ...defaultFurnitureColumn,
    headerName: t('placement.placementMods.costToTraveler'),
    field: 'costToTraveler',
    width: 119,
    hide: false,
    align: 'right',
    type: 'number',
    editable: isModEdit,

    renderCell: CostToTraveler,
    renderEditCell: CostToTravelerCell({
      gridIdentifier: 'Utility',
    }),
    preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      if (isInvalidFieldBasedOnInclude(params?.row?.include, params?.row?.costToTraveler)) {
        return { ...params.props.row, error: true, errorField: 'costToTraveler' };
      } else {
        return { ...params.props, error: false, errorField: null };
      }
    },
    cellClassName: params => {
      if (isInvalidFieldBasedOnInclude(params?.row?.include, params?.row?.costToTraveler)) {
        return classes.isErrorCell;
      } else {
        return null;
      }
    },
    sortComparator: xGridNumberSort,
  },
  {
    field: 'billable',
    headerName: t('placement.placementMods.billable'),
    width: 144,
    hide: false,
    editable: isModEdit,

    renderCell: FurnitureUtility,
    renderEditCell: BillableCell,
  },
];
